import React from "react";
import ReactMarkdown from "react-markdown";
import * as cls from "./markdownReportModal.module.scss";
import { IoClose } from "react-icons/io5";

function MarkdownReportModal({ content, onClose }) {
  if (!content) return null;
  return (
    <div className={cls.overlay} onClick={onClose}>
      <div className={cls.window} onClick={(e) => e.stopPropagation()}>
        <button className={cls.closeBtn} onClick={onClose} aria-label="Закрыть">
          <IoClose size={24} title="Закрыть" />
        </button>
        <div className={cls.content}>
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default MarkdownReportModal;
